<template>
  <div>
    <div>
      <v-card flat class="pa-4" rounded="t-lg">
        <v-img
          :src="'data:image;base64,' + PreviewImages.showCoverImageInPreview"
          height="200px"
        ></v-img>
        <v-card outlined flat rounded="b-lg-0">
          <div class="pa-4">
            <span class="text-card-head">{{ price.ProductName }}</span>
            <div class="text-style-cut">
              <span
                class="text-decoration-line-through"
                style="color: rgba(8, 8, 22, 0.38)"
                >{{ price.Discount }}
              </span>
            </div>
            <div class="d-flex justify-space-between">
              <div class="d-flex justify-start">
                <span class="text-price"> ${{ price.PublicPrice }} </span>
                <span class="ml-2 text-OFF mt-2"  v-if="price.DiscountPercentage">
                  {{ price.DiscountPercentage }}% OFF</span
                >
              </div>
              <div class="d-flex justify-end">
                <v-btn text class="text-shop">
                  <v-icon class="pr-1" size="16px" color="primary"
                    >mdi-basket
                  </v-icon>
                  <span class="mt-1"> Add To Cart </span>
                </v-btn>
              </div>
            </div>

            <div class="text-style-des mt-2" v-html="price.ProductDescription">
            </div>
          </div>
        </v-card>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["price", "PreviewImages"],
  data: () => ({
    items: [
      "Public",
      "Starter",
      "Access",
      "Life Science",
      "Standard",
      "Practitioner",
      "Instructor",
    ],
    offprice: "20% OFF",
    profileImge: "https://cdn.vuetifyjs.com/images/cards/docks.jpg",
    titletext: "Cortices Technique Cards(10 pack)",
    certified: "false",

    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius dictumst turpis at tincidunt at",
  }),
  methods: {
    imageUrl(data) {
      return data ? data : "";
    },
  },
};
</script>

<style scoped>
.text-OFF {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #27ae60;
  margin-left: 40px;
}
.text-shop {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;

  color: #1884cd;
}
.text-stock {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;

  text-transform: uppercase;

  color: #eb5757;
}
.text-style-des {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #828282;
}
.text-card-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;

  color: #222222;
}
.text-style-cut {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-decoration-line: line-through;

  color: rgba(8, 8, 22, 0.38);
}
.text-price {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 29px;
  color: rgba(34, 34, 34, 0.7);
}
.text-40 {
  font-family: "Noto Serif";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 54px;
  text-align: center;
  letter-spacing: -0.02em;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
</style>
